import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Pencil, Trash2 } from "lucide-react";

interface CategoryItemProps {
  category: {
    id: string;
    name: string;
  };
  onEdit: (category: { id: string; name: string }) => void;
  onDelete: (id: string) => void;
}

export const CategoryItem = ({ category, onEdit, onDelete }: CategoryItemProps) => {
  return (
    <Card>
      <CardContent className="flex items-center justify-between p-4">
        <span className="text-lg">{category.name}</span>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onEdit(category)}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="destructive"
            size="icon"
            onClick={() => onDelete(category.id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};